export default class Header {
	constructor() {
		this.$window = $(window);
		this.$header = $('.js-header');
		this.scrollPosition = $(window).scrollTop();
	}

	onScroll() {
		const scrollTop = this.$window.scrollTop();
		const fixedCheck = scrollTop > 5 ? true : false;
		const threshold = this.$header.height();

		if( 
			scrollTop > this.scrollPosition
			&& !this.$header.hasClass('js-is-hidden')
		){
			this.$header
				.css('transform', `translateY(${-this.$header.outerHeight()}px)`)
			    .removeClass('js-is-hidden');
		}else{
			this.$header
				.css('transform', 'translateY(0)')
				.removeClass('js-is-hidden');
		}		

		if( scrollTop <= 0 ){
			this.$header
				.css('transform', 'translateY(0)')
				.removeClass('js-is-hidden');			
		}

		this.scrollPosition = scrollTop;
	}

	setEventBindings() {
		this.$window.on('scroll load', this.onScroll.bind(this));
	}

	init() {
		this.setEventBindings();
	}
}


// WEBPACK FOOTER //
// ./wp-content/themes/indiana811/source/scripts/components/Header.js